import { createSlice } from '@reduxjs/toolkit';
import {
  updateMessageBarSuccessState,
  updateMessageBarErrorState,
  updateMessageBarInfoState,
  updateMessageBarMultipleErrorsState,
  addMessageBarError,
  removeMessageBarError,
  clearAllMessageBarErrors,
  showWarningMessageBar,
  hideWarningMessageBar,
  addSensitiveInfoField,
  removeSensitiveInfoField,
  clearAllSensitiveInfoFields,
} from '../actions/messageBarActions';
import { IMessageBarState } from '../../interfaces/MessageBar';

const initialState: IMessageBarState = {
  messageBarSuccessMeg: '',
  isShowMessageBarSuccessMeg: false,
  messageBarErrorMeg: '',
  isShowMessageBarErrorMeg: false,
  messageBarErrorAction: undefined,
  messageBarInfoMeg: '',
  isShowMessageBarInfoMeg: false,
  messageBarInfoTooltip: {
    messageBarInfoMegTooltip: '',
    isShowMessageBarInfoMegTooltip: false,
  },
  messageBarErrors: [],
  isShowMultipleErrors: false,
  //Disaply invalid user
  warningMessageBar : {
    isShow : false,
    message : '',
    timeOut : undefined,
  },
  sensitiveInfoFields: [],
};

const messageBarSlice = createSlice({
  name: 'messageBar',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateMessageBarSuccessState, (state, action) => {
      state.messageBarSuccessMeg = action.payload.messageBarSuccessMeg;
      state.isShowMessageBarSuccessMeg = action.payload.isShowMessageBarSuccessMeg;
    });
    builder.addCase(updateMessageBarErrorState, (state, action) => {
      state.messageBarErrorMeg = action.payload.messageBarErrorMeg;
      state.isShowMessageBarErrorMeg = action.payload.isShowMessageBarErrorMeg;

      if (action?.payload?.messageBarErrorAction) {
        state.messageBarErrorAction = action.payload.messageBarErrorAction;
      } else {
        state.messageBarErrorAction = undefined;
      }
    });
    builder.addCase(updateMessageBarInfoState, (state, action) => {
      state.messageBarInfoMeg = action.payload.messageBarInfoMeg;
      state.isShowMessageBarInfoMeg = action.payload.isShowMessageBarInfoMeg;
      state.messageBarInfoTooltip = action.payload.messageBarInfoTooltip;
    });
    builder.addCase(updateMessageBarMultipleErrorsState, (state, action) => {
      state.messageBarErrors = action.payload.errors;
      state.isShowMultipleErrors = action.payload.isShow;
    });
    builder.addCase(addMessageBarError, (state, action) => {
      if (!state.messageBarErrors) {
        state.messageBarErrors = [];
      }
      // Check if error with same id already exists
      const existingIndex = state.messageBarErrors.findIndex(
        (error) => error.id === action.payload.id
      );
      if (existingIndex >= 0) {
        // Update existing error
        state.messageBarErrors[existingIndex] = action.payload;
      } else {
        // Add new error
        state.messageBarErrors.push(action.payload);
      }
      state.isShowMultipleErrors = true;
    });
    builder.addCase(removeMessageBarError, (state, action) => {
      if (state.messageBarErrors) {
        state.messageBarErrors = state.messageBarErrors.filter(
          (error) => error.id !== action.payload.id
        );
        state.isShowMultipleErrors = state.messageBarErrors.length > 0;
      }
    });
    builder.addCase(clearAllMessageBarErrors, (state) => {
      state.messageBarErrors = [];
      state.isShowMultipleErrors = false;
    });
    builder.addCase(showWarningMessageBar, (state,action) => {
      state.warningMessageBar.isShow = true;
      state.warningMessageBar.message = action.payload.message;
      state.warningMessageBar.timeOut = action.payload.timeOut;
    });
    builder.addCase(hideWarningMessageBar, (state) => {
      state.warningMessageBar.isShow = false;
      state.warningMessageBar.message = '';
      state.warningMessageBar.timeOut = undefined;
    });
    builder.addCase(addSensitiveInfoField, (state, action) => {
      if (!state.sensitiveInfoFields.includes(action.payload.fieldName)) {
        state.sensitiveInfoFields.push(action.payload.fieldName);
      }
    });
    builder.addCase(removeSensitiveInfoField, (state, action) => {
      state.sensitiveInfoFields = state.sensitiveInfoFields.filter(
        (field) => field !== action.payload.fieldName
      );
    });
    builder.addCase(clearAllSensitiveInfoFields, (state) => {
      state.sensitiveInfoFields = [];
    });
  },
});

export default messageBarSlice.reducer;
